import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async index() {
    return await api(route('api.v1.roles.index'), 'get');
  },
};
